export default __webpack_public_path__ + "static/media/GEM_TOKEN.ed06b6e6.svg";